import moment from "moment";
import { LibrarySort, LibraryTemplate } from "./templateLibrary.types";

export const ALL_CATEGORY = "All";

export const pagesLabel = (count: number) =>
  `${count} ${count === 1 ? "page" : "pages"}`;

export const documentsLabel = (count: number) =>
  `${count} ${count === 1 ? "document" : "documents"}`;

/** "Sep 30, 2026" from the API's ISO date-time; empty when missing. */
export const formatUpdated = (updatedOn?: string | null) =>
  updatedOn && moment(updatedOn).isValid()
    ? moment(updatedOn).format("MMM D, YYYY")
    : "";

/** Sort menu, in menu order; the first is the default, as in the design. */
export const LIBRARY_SORTS: { value: LibrarySort; label: string }[] = [
  { value: "newest", label: "Newest" },
  { value: "popular", label: "Most popular" },
  { value: "name", label: "Name (A–Z)" },
];

/** A template with more than one document is shown as a kit. */
export const isKit = (template: LibraryTemplate) =>
  (template.documentCount ?? 0) > 1;

/**
 * Card footer: "4 documents · 12 pages · Updated Sep 12, 2026" for a kit,
 * "3 pages · Updated …" otherwise. The page count is the server's (read from
 * the PDFs) and is left out while it is 0, i.e. not counted yet.
 */
export const cardMeta = (template: LibraryTemplate) => {
  const updated = formatUpdated(template.updatedOn);
  return [
    isKit(template) ? documentsLabel(template.documentCount) : "",
    template.pageCount > 0 ? pagesLabel(template.pageCount) : "",
    updated ? `Updated ${updated}` : "",
  ]
    .filter(Boolean)
    .join(" · ");
};
